import sendToast from '@/lib/sendToast.js';
import { useAnalytics } from '@/hooks/useAnalytics.js';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import selectors from '@/redux/selectors/selectors.js';
import workflowActions from '@/screens/workflows/redux/actions/workflowActions.js';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';
import { useSelector } from 'react-redux';
import FloatingSelectV2 from '@/components/v2/FloatingSelectV2';
import Button from '@/components/Button';
import workflowStageOptions from '@/schema/workflowStageOptions';
import useResponsive from '@/hooks/useResponsive.js';

const WorkflowStageButton = () => {
  const canEdit = useArgSelector(selectors.permission, 'workflow:edit');
  const workflowStage = useSelector((state) => workflowScreenSelectors.activeWorkflowMetadata(state)?.stage) || 'requirements';
  const { trackEvent } = useAnalytics();
  const { mobile } = useResponsive();

  const label = workflowStageOptions.find((option) => option.value === workflowStage)?.label || workflowStageOptions[0]?.label;
  const icon = workflowStageOptions.find((option) => option.value === workflowStage)?.icon || workflowStageOptions[0]?.icon;

  const handleWorkflowStageChange = async ({ value }) => {
    if (!canEdit) {
      sendToast({ message: 'You do not have permission to perform this action.' });
      return;
    }

    trackEvent('workflow-updateStage');
    workflowActions.setMetadata('stage', value);
  };

  if (mobile) {
    return null;
  }

  return (
    <>
      <Button className="workflow-stage-button outline" icon={icon}>
        {label}
      </Button>
      <FloatingSelectV2 triggers={[`.workflow-stage-button`]} value={workflowStage} options={workflowStageOptions} onChange={handleWorkflowStageChange} matchTriggerWidth multiple={false} fullDisplay={false} useSearch={false} nullable={false} loading={false} />
    </>
  );
};

export default WorkflowStageButton;
